import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LoadService {

    private loadingStatus: Subject<boolean> = new Subject<boolean>();

    activateLoading() {
        this.loadingStatus.next(true);
    }

    deactiveLoading() {
        this.loadingStatus.next(false)
    }

    getLoadingStatus(): Observable<boolean> {
        return this.loadingStatus.asObservable();
    }
}